export let BASE_URL_API;
export let ID_URL;
export let BASE_URL_API2;
export let ORIGIN;
export let ORIGINS_ALLOWED;

if (process.env.NODE_ENV == 'development') {
  BASE_URL_API = 'https://localhost:4001/';
  BASE_URL_API2 = 'https://localhost:4001/';
  ID_URL = 'https://localhost:5001/';
  ORIGIN = 'http://localhost:8080';
  ORIGINS_ALLOWED = ['http://localhost:8080'];
} else {
  BASE_URL_API = 'https://api.serranaleiloes.com.br/';
  BASE_URL_API2 = 'https://api.serranaleiloes.com.br/';
  ID_URL = 'https://id.serranaleiloes.com.br/';
  ORIGIN = 'https://leiloesnovaserrana.com.br';
  ORIGINS_ALLOWED = [
    'https://leiloesnovaserrana.com.br',
    'https://www.leiloesnovaserrana.com.br',
    'https://www.serranaleiloes.com.br',
    'https://serranaleiloes.com.br',
    'https://ruamgotardoleiloes.com.br',
    'https://www.ruamgotardoleiloes.com.br',
    'https://lorranaleiloes.com.br',
    'https://www.lorranaleiloes.com.br',
  ];
}
